import AddressService from 'services/AddressService';
import AdminService from 'services/AdminService';
import BillingsService from 'services/BillingsService';
import BillsService from 'services/BillsService';
import ContractPreferencesService from 'services/ContractPreferencesService';
import ContractsService from 'services/ContractsService';
import DebtAgreementRulesService from 'services/DebtAgreementRulesService';
import InstitutionsService from 'services/InstitutionsService';
import ReenrollmentContractsService from 'services/ReenrollmentContractsService';
import StudentCardsService from 'services/StudentCardsService';
import StudentsService from 'services/StudentsService';
import LevelsService from 'services/LevelsService';
import RecipientsService from 'services/RecipientsService';
import TransferDaysService from 'services/TransferDaysService';

export default {
  loadAllStudentFields({ dispatch }, studentId) {
    return dispatch('loadStudent', studentId)
      .then(() => dispatch('loadStudentBillings', studentId))
      .then(() => dispatch('loadStudentContracts', studentId))
      .then(() => dispatch('loadStudentCards', studentId))
      .then(() => dispatch('loadStates'))
      .then(() => dispatch('loadCities'));
  },

  clearStudentData({ commit }) {
    commit('setStudent', null);
    commit('setStudentBillings', null);
    commit('setStudentContracts', null);
    commit('setStudentBills', null);
    commit('setStudentCards', null);
    commit('setCities', null);
    commit('setInstitution', null);
  },

  loadStudent({ commit }, studentId) {
    return StudentsService.getStudent(studentId)
      .then(student => commit('setStudent', student));
  },

  loadStudentBillings({ commit, state }, studentId = state.student.id) {
    return BillingsService.getStudentBillings(studentId)
      .then(billings => commit('setStudentBillings', billings));
  },

  loadStudentContracts({ commit, state, dispatch }) {
    return ContractsService.getStudentContracts(state.studentBillings.map(billing => billing.id))
      .then((contracts) => {
        commit('setStudentContracts', contracts);
        if (contracts.length) {
          dispatch('loadStudentBills');
        }
      });
  },

  loadStudentBills({ commit, state }) {
    return BillsService.getStudentBills(state.studentContracts.map(contract => contract.id))
      .then(bills => commit('setStudentBills', bills));
  },

  loadStudentCards({ commit, state }, studentId = state.student.id) {
    return StudentCardsService.getStudentCards(studentId)
      .then(studentCards => commit('setStudentCards', studentCards));
  },

  loadStates({ commit }) {
    return AddressService.getStates()
      .then(({ data }) => commit('setStates', data.states));
  },

  loadCities({ commit, state }) {
    return AddressService.getCities(state.student.state_id)
      .then(({ data }) => commit('setCities', data.cities));
  },

  loadInstitution({ commit }, institutionId) {
    return InstitutionsService.getInstitution(institutionId)
      .then(({ data }) => {
        commit('setInstitution', data);
      });
  },

  loadBanks({ commit }) {
    return AdminService.getBanks().then(({ data }) => commit('setBanks', data));
  },

  loadReenrollmentContracts({ commit }, institutionId) {
    return ReenrollmentContractsService.getReenrollmentContracts(institutionId)
      .then(({ data }) => {
        commit('setReenrollmentContracts', data);
      });
  },

  loadDisallowedReasons({ commit, state }) {
    if (state.disallowedReasons && state.disallowedReasons.length) {
      return Promise.resolve(state.disallowedReasons);
    }

    return ContractPreferencesService.loadDisallowedReasons()
      .then(({ data }) => {
        commit('setDisallowedReasons', data);
        return data;
      });
  },

  loadInterruptionReasons({ commit, state }) {
    if (state.interruptionReasons && state.interruptionReasons.length) {
      return Promise.resolve(state.interruptionReasons);
    }

    return BillingsService.loadInterruptionReasons()
      .then(({ data }) => {
        commit('setInterruptionReasons', data);
        return data;
      });
  },

  loadEnumsDebtAgreementRules({ commit, state }) {
    if (state.debtAgreementRules && Object.keys(state.debtAgreementRules).length) {
      return Promise.resolve(state.debtAgreementRules);
    }

    return DebtAgreementRulesService.loadEnumsDebtAgreementRules()
      .then(({ data }) => {
        commit('setDebtAgreementRules', data);
        return data;
      });
  },

  loadLevels({ commit, state }) {
    if (state.levels && state.levels.length) {
      return Promise.resolve(state.levels);
    }

    return LevelsService.getAll()
      .then((levels) => {
        const levelsParsed = levels.map(level => ({ label: level.name, value: level.id }));
        commit('setLevels', levelsParsed);
        return levelsParsed;
      });
  },

  loadSelectedBill({ commit }, billId) {
    return BillsService.getBill(billId)
      .then(data => commit('setSelectedBill', data));
  },

  loadPaymentDetails({ commit }, billId) {
    return BillsService.paymentDetails(billId)
      .then(data => commit('setPaymentDetails', data));
  },

  loadRecipients({ commit }, institutionId) {
    return RecipientsService.get(institutionId).then(data => commit('setRecipients', data));
  },

  loadQueroPagoRecipient({ commit, state }) {
    if (state.queroPagoRecipient) {
      return Promise.resolve(state.queroPagoRecipient);
    }

    return RecipientsService.getRecipientQueroPago().then(data => commit('setQueroPagoRecipient', data));
  },

  loadTransferDays({ commit }, institutionId) {
    return TransferDaysService.get(institutionId).then(data => commit('setTransferDays', data));
  },

  loadRecipientEnums({ commit }) {
    return RecipientsService.enums().then(data => commit('setRecipientEnums', data));
  },
};
